import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=0bc608d2&scoped=true"
import script from "./RequestStatus.vue?vue&type=script&lang=js"
export * from "./RequestStatus.vue?vue&type=script&lang=js"
import style0 from "./RequestStatus.vue?vue&type=style&index=0&id=0bc608d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc608d2",
  null
  
)

export default component.exports